module.exports = __webpack_public_path__ + "img/app-apk.4fb20c1.svg";